import { PIX_TRANSFER_MODES } from "./constants";

export const PixTransferModeSelector = ({ value, onChange, disabled = false }) => (
  <div
    className="pix-transfer-segment"
    role="tablist"
    aria-label="Tipo de transferência Pix"
  >
    {PIX_TRANSFER_MODES.map((mode) => {
      const Icon = mode.icon;
      const isActive = value === mode.id;

      return (
        <button
          key={mode.id}
          type="button"
          role="tab"
          aria-selected={isActive}
          disabled={disabled}
          className={`pix-transfer-segment__btn ${
            isActive ? "pix-transfer-segment__btn--active" : ""
          } ${disabled ? "pix-transfer-segment__btn--disabled" : ""}`}
          onClick={() => onChange(mode.id)}
        >
          <Icon className="h-4 w-4 shrink-0" />
          {mode.label}
        </button>
      );
    })}
  </div>
);
